import { useState, useEffect } from "react";

import { 
    collection, query, where, doc, updateDoc, onSnapshot, Timestamp,
    orderBy
} from 'firebase/firestore';
import { db } from '../../firebase/config';
import { PROYECTOS_COLLECTION} from '../../utils/constants';
import { formatDate} from '../../utils/helpers';
import { toast } from 'react-toastify';

export const ProjectManagementModal = ({ project, onClose, onUpdate, user, userData, userRole }) => {
    const [formData, setFormData] = useState({
        prioridad: project.prioridad || "1 - Normal",
        fechaEntregaInterna: project.fechaEntregaInterna ? project.fechaEntregaInterna.toDate().toISOString().split('T')[0] : '',
        notasSupervisor: project.notasSupervisor || '',
        precioCotizacionCliente: project.precioCotizacionCliente || '',
        costoProveedor: project.costoProveedor || '',
        cotizacionClienteRef: project.cotizacionClienteRef || '',
        poClienteRef: project.poClienteRef || '',
        cotizacionProveedorRef: project.cotizacionProveedorRef || '',
    });
    const [loading, setLoading] = useState(false);
    const [logEntries, setLogEntries] = useState([]);
    const [loadingLogs, setLoadingLogs] = useState(true);

    useEffect(() => {
        setLoadingLogs(true);
        const q = query(
            collection(db, "bitacoras_proyectos"),
            where("projectId", "==", project.id),
            orderBy("fecha", "desc")
        );
        const unsubscribe = onSnapshot(q, (snapshot) => {
            setLogEntries(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
            setLoadingLogs(false);
        });
        return () => unsubscribe();
    }, [project.id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSave = async () => {
        setLoading(true);
        const projectRef = doc(db, PROYECTOS_COLLECTION, project.id);
    
        const updatePayload = {};

        if (userRole === 'supervisor') {
            updatePayload.prioridad = formData.prioridad;
            updatePayload.fechaEntregaInterna = formData.fechaEntregaInterna ? Timestamp.fromDate(new Date(formData.fechaEntregaInterna)) : null;
            updatePayload.notasSupervisor = formData.notasSupervisor;
        } else if (userRole === 'administrador') {
            updatePayload.precioCotizacionCliente = Number(formData.precioCotizacionCliente) || 0;
            updatePayload.costoProveedor = Number(formData.costoProveedor) || 0;
            updatePayload.cotizacionClienteRef = formData.cotizacionClienteRef;
            updatePayload.poClienteRef = formData.poClienteRef;
            updatePayload.cotizacionProveedorRef = formData.cotizacionProveedorRef;
        }

        try {
            if (Object.keys(updatePayload).length > 0) {
                await updateDoc(projectRef, updatePayload);
            }
            onUpdate();
            onClose();
            toast.success("Proyecto actualizado correctamente.");
        } catch (err) {
            toast.error("Error al guardar los cambios.");
            console.error("Error al guardar:", err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
            <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-lg">
                <h3 className="text-lg font-bold mb-4">Gestionar Proyecto: {project.npu}</h3>
                <div className="space-y-4 max-h-[60vh] overflow-y-auto pr-2">
                    
                    {userRole === 'supervisor' && (
                            <>
                                <div>
                                    <label className="block text-sm font-medium">Prioridad</label>
                                    <select name="prioridad" value={formData.prioridad}onChange={handleChange}className="mt-1 block w-full p-2 border rounded-md"
                                    >
                                        <option value="1 - Normal">Normal</option>
                                        <option value="2 - Alta">Alta</option>
                                        <option value="3 - Urgente">Urgente</option>
                                    </select>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium">Fecha Límite de Entrega</label>
                                    <input type="date" name="fechaEntregaInterna" value={formData.fechaEntregaInterna} onChange={handleChange} className="mt-1 block w-full p-2 border rounded-md"/>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium">Notas del Supervisor</label>
                                    <textarea name="notasSupervisor" value={formData.notasSupervisor} onChange={handleChange} rows="8" className="mt-1 block w-full p-2 border rounded-md"></textarea>
                                </div>
                            </>
                        )}

                    {userRole === 'administrador' && (
                        <>
                            <div className="grid grid-cols-2 gap-4">
                                <input type="number" name="precioCotizacionCliente" value={formData.precioCotizacionCliente} onChange={handleChange} placeholder="Precio Cliente" className="px-3 py-2 border rounded-md"/>
                                <input type="number" name="costoProveedor" value={formData.costoProveedor} onChange={handleChange} placeholder="Costo Proveedor" className="px-3 py-2 border rounded-md"/>
                            </div>
                            <input type="text" name="cotizacionClienteRef" value={formData.cotizacionClienteRef} onChange={handleChange} placeholder="Ref. Cotización Cliente" className="w-full px-3 py-2 border rounded-md"/>
                            <input type="text" name="poClienteRef" value={formData.poClienteRef} onChange={handleChange} placeholder="Ref. PO Cliente" className="w-full px-3 py-2 border rounded-md"/>
                            <input type="text" name="cotizacionProveedorRef" value={formData.cotizacionProveedorRef} onChange={handleChange} placeholder="Ref. Cotización Proveedor" className="w-full px-3 py-2 border rounded-md"/>
                        </>
                    )}
                    {userRole === 'supervisor' && ( 
                        <div>
                            <label className="block text-sm font-medium mb-1">Bitácora (Solo Lectura)</label>
                            <div className="bg-gray-50 border rounded-md p-2 h-96 overflow-y-auto space-y-2">
                                {loadingLogs ? <p>Cargando...</p> : logEntries.length > 0 ? logEntries.map(entry => (
                                    <div key={entry.id} className="text-xs border-b pb-1">
                                        <p className="text-gray-800 whitespace-pre-wrap">{entry.mensaje}</p>
                                        {entry.adjuntoUrl && <a href={entry.adjuntoUrl} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Ver adjunto</a>}
                                        <p className="text-gray-500 mt-1 text-right">{entry.autorNombre} - {formatDate(entry.fecha)}</p>
                                    </div>
                                )) : <p className="text-gray-500">No hay entradas.</p>}
                            </div>
                        </div>
                    )}    
                </div>
                <div className="flex justify-end space-x-3 mt-6">
                    <button onClick={onClose} className="bg-gray-300 hover:bg-gray-400 font-bold py-2 px-4 rounded">Cancelar</button>
                    <button onClick={handleSave} disabled={loading} className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">{loading ? 'Guardando...' : 'Guardar Cambios'}</button>
                </div>
            </div>
        </div>
    );
};